module.exports = __webpack_public_path__ + "img/sweet_snack.8202dccd.png";